import React from "react";
import ProductionAgency from "../../Assets/production-agency.png";

export default function ProductionAgencySection() {
  return (
		<section className="w-full bg-white">
			<div className="grid grid-cols-2 items-center my-5 md:my-10 lg:my-16">
				<div className="max-w-[1400px] flex justify-center w-full py-10 pl-3 lg:pl-20 ">
					<p className="text-md  text-start md:text-[2rem] md:leading-[2.3rem] lg:text-[3.2rem] lg:leading-[3.5rem]  text-gray-800 max-w-3xl">
						We Partner To Grow Your{" "}
						<span className="font-bold text-lg lg:text-[3.5rem]  text-start text-brand-green">
							Production
						</span>
						<br />
						<span className="font-bold text-brand-green">Agency</span>
					</p>
				</div>

				<div>
					<img
						src={ProductionAgency}
						alt="Production Agency"
						className=" object-cover  ml-auto rounded-l-lg"
					/>
				</div>
			</div>

			<div className="bg-black text-center py-6 md:py-16">
				<h2 className="text-[#84CC16] text-xl md:text-[2.8em] font-bold md:mb-4 lg:mb-7">
					Video Production
				</h2>
				<p className="text-white text-xl md:text-[2rem]  md:leading-[2.5rem] font-bold">
					Specialized Sales Strategy
				</p>
			</div>
		</section>
	);
}
